import { useEffect, type ReactNode } from 'react';
import { Center, Column, Screen, StepperIndicator } from '@tempmee/react';
import { BackButton } from '~/commonComponents';

const SHIFT_REQUEST_STEPS = ['Select Dates', 'Shift Details', 'Add Invites', 'Review & Confirm'];

interface IShiftRequestHeaderProps {
  currentStep: number;
  onBack?: () => void;
  backUrl?: string;
  maxWidth?: number;
  children: ReactNode;
}

export const ShiftRequestHeader = ({
  currentStep,
  onBack,
  backUrl,
  maxWidth,
  children,
}: IShiftRequestHeaderProps) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Screen variant="standard">
      <Screen.Header start={<BackButton onClick={onBack} url={backUrl} />} title="Shift Request" />
      <Screen.Body style={maxWidth ? { maxWidth, width: '100%', alignSelf: 'center' } : undefined}>
        <Column pt={6} gap={8} style={{ paddingLeft: 28, paddingRight: 28, paddingBottom: 28 }}>
          <Center>
            <StepperIndicator steps={SHIFT_REQUEST_STEPS} currentStep={currentStep} />
          </Center>
          {children}
        </Column>
      </Screen.Body>
    </Screen>
  );
};
